<template>
  <div class="c-startpage-hero-element-tile-detailed">
    <NuxtLink class="entry flex flex-col bg-white lg:h-[500px]" :to="entry.cta.url" :external="true">
      <div
        class="flex flex-col gap-8 justify-start h-1/2 items-center w-full bg-center bg-no-repeat bg-cover"
      >
        <img v-if="entry.image && (entry.image.alt || entry.altText || entry?.description)" :src="entry.image.url" :alt="entry.image.alt && entry.image.alt != '' ? entry.image.alt : entry.altText && entry.altText != '' ? entry.altText : entry.description" class="w-full" fetchpriority="high">
      </div>
      <div
        class="flex flex-col justify-between gap-2 lg:gap-4 h-1/2 p-4 pt-2 w-full min-h-[250px]"
      >
        <div class="flex flex-col gap-2 px-4 grow justify-center">
          <div>
            <StartpageHeroElementBadges :badges="(entry.badges as string[])" />
            <BasicBtErrorBoundary>
              <div v-if="entry.brandId">
                <ArticleExpBrand
                  :enable-link="true"
                  :img-class="'max-h-8'"
                  :brand-id="entry.brandId"
                  :show-logo="true"
                />
              </div>
            </BasicBtErrorBoundary>
            <div
              v-if="entry.headline"
              class="text-xl lg:text-xl font-extrabold line-clamp-2 sm:line-clamp-1"
              :class="entry.headlineOrange ? 'text-primary':'text-paragraph'"
              :title="entry.headline"
              v-text="entry.headline"
            />
          </div>
          <div
            v-if="entry?.description"
            class="text-sm lg:text-base"
            :class="entry.brandId || (entry.badges && entry.badges.length > 0) ? (outputRestricted ? 'line-clamp-2' : 'line-clamp-3') : (outputRestricted ? 'line-clamp-4' : '')"
            v-text="entry?.description"
          />
          <div v-if="entry.timedOffer">
            <StartpageHeroElementCountdown
              :message="entry.timedOfferText ?? 'Die Angebote enden in'"
              :label-text-day="'Tagen'"
              :label-text-hour="'Stunden'"
              :label-text-minute="'Minuten'"
              :label-text-seconds="'Sekunden'"
              :timed-offer="entry.timedOffer"
            />
          </div>
        </div>
        <div v-if="entry.cta.url">
          <div
            class="text-center font-bold text-sm text-primary-contrast bg-primary rounded-full py-3 lg:pb-4 px-8 w-full inline-block"
            v-text="entry.cta.label"
          />
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
interface Entry {
  cta: { label: string; url: string };
  image: { url:string, alt:string };
  badges?: string[];
  brandId?: string;
  headline?: string;
  description?: string;
  type: string;
  callout?: string;
  timedOffer?: string;
  timedOfferText?: string;
  priority?: string;
  altText: string;
  headlineOrange?: boolean;
}

withDefaults(defineProps<{
  entry: Entry;
  outputRestricted?: boolean;
}>(), {
  outputRestricted: true
});
</script>
